// extracted by mini-css-extract-plugin
export default {"inputs_wrapper":"NY","reactivation_inputs_wrapper":"OY","name_input":"PY","street_input":"QY","address_inputs_wrapper":"RY","state_select":"SY","zip_code":"TY","inputs_wrapper_add_address":"UY","overflowed":"VY","city_input":"WY"};
    if(module.hot) {
      // 1715276859770
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  